import React from 'react';

const IconFilter = () => {
	return <em className="fa-light fa-filter"></em>;
};

export default IconFilter;